import type { AuthenticationState } from './authState';

/** UI visibility only; private-library endpoints independently enforce access. */
export function canReviewCurveLibrary(
  authentication: Pick<AuthenticationState, 'mode' | 'session'> | null,
): boolean {
  return authentication?.mode === 'local' || (
    authentication?.mode === 'hosted-authenticated' &&
    authentication.session?.user.is_active === true &&
    authentication.session.user.role === 'admin'
  );
}
